import { showNotification } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";

import { authPost } from "@shared/api";
import { ApiError, OrgData } from "@shared/types";
import { queryClient } from "@shared/utils";

const createDeployment = async (deployment_name: string): Promise<OrgData> => {
  return authPost<
    { deployment_name: string; source_type: string; source_id?: string },
    { deployment: OrgData }
  >("/api/agent/deployments", {
    deployment_name,
    source_type: "simple",
    source_id: "",
  }).then((response) => {
    return response.deployment;
  });
};

export const useCreateDeploymentMutation = () => {
  return useMutation({
    mutationFn: (deploymentName: string) => createDeployment(deploymentName),
    onError: (err: ApiError, deploymentName) => {
      showNotification({
        message:
          err.message ||
          `There was an issue creating the organization "${deploymentName}".`,
      });
    },
    onSuccess: () => {
      // NOTE: Coupling with the `useUserOrgs` hook, we invalidate the current user's orgs
      queryClient.invalidateQueries({ queryKey: ["userDeployments"] });
    },
  });
};
